import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["description", "form", "input"];

  toggleCheckbox(event) {
    if (!this.hasInputTarget) {
      console.error("No input target found");
      return;
    }

    const checkboxInput = event.target;
    const checkboxIndex = parseInt(checkboxInput.dataset.checkboxIndex);
    const description = this.inputTarget.value;

    let count = 0;
    const checkboxPattern = /\[([ xX])\]/gi;
    const newText = description.replace(checkboxPattern, (match) => {
      count++;
      if (count === checkboxIndex) {
        return checkboxInput.checked ? "[x]" : "[ ]";
      }
      return match;
    });

    // Create and submit form data
    const formData = new FormData();
    formData.append("task[description]", newText);
    formData.append(
      "task[id]",
      this.formTarget.querySelector('input[type="hidden"]').value,
    );

    const updateUrl = this.formTarget.dataset.taskListUrlValue;

    fetch(updateUrl, {
      method: "PATCH",
      body: formData,
      headers: {
        Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => console.error("Error updating checkbox:", error));
  }
}
